"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _PageVisibility = _interopRequireDefault(require("crm_ui/browser/PageVisibility"));

var _TimelineWrapper = _interopRequireDefault(require("crm_ui/timeline/components/config/TimelineWrapper"));

var propTypes = {
  activityTabIsSelected: _propTypes.default.bool.isRequired,
  emailTabIsSelected: _propTypes.default.bool,
  objectType: _ObjectTypesType.default.isRequired,
  onVisibilityChange: _propTypes.default.func.isRequired,
  profileStartTime: _propTypes.default.number.isRequired,
  subjectId: _propTypes.default.string.isRequired
};

var TimelineWithPinnedContent =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TimelineWithPinnedContent, _React$Component);

  function TimelineWithPinnedContent() {
    (0, _classCallCheck2.default)(this, TimelineWithPinnedContent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineWithPinnedContent).apply(this, arguments));
  }

  (0, _createClass2.default)(TimelineWithPinnedContent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var activityTabIsSelected = _ref.activityTabIsSelected,
          emailTabIsSelected = _ref.emailTabIsSelected;
      return this.props.activityTabIsSelected !== activityTabIsSelected || this.props.emailTabIsSelected !== emailTabIsSelected;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activityTabIsSelected = _this$props.activityTabIsSelected,
          objectType = _this$props.objectType,
          onVisibilityChange = _this$props.onVisibilityChange,
          subjectId = _this$props.subjectId,
          emailTabIsSelected = _this$props.emailTabIsSelected,
          profileStartTime = _this$props.profileStartTime;
      return _react.default.createElement("div", null, _react.default.createElement(_PageVisibility.default, {
        key: "timelineContainer",
        onChange: onVisibilityChange
      }, _react.default.createElement("div", {
        className: "onboarding-peek-timeline"
      }, _react.default.createElement(_TimelineWrapper.default, {
        renderPinnedContent: this.renderPinnedContent,
        subjectId: subjectId,
        objectType: objectType,
        activityTabIsSelected: activityTabIsSelected,
        emailTabIsSelected: emailTabIsSelected,
        profileStartTime: profileStartTime
      }))));
    }
  }]);
  return TimelineWithPinnedContent;
}(_react.default.Component);

TimelineWithPinnedContent.propTypes = propTypes;
var _default = TimelineWithPinnedContent;
exports.default = _default;
module.exports = exports.default;